<script lang="ts" setup>
import { ref, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import { usePGRESTAPIStore } from "../store/pgrest_api";
import PGRESTResult from "../classes/PGRESTResult";
import { DateTime } from "luxon";
import {
  Edit,
  Delete,
  Notebook,
  Plus,
  RefreshLeft,
  DataLine,
  Watch,
  CircleCheck,
  CircleClose,
  Lock
} from "@element-plus/icons-vue";
import MonitoringDetails from "../components/MonitoringDetails.vue";
import { ElMessage } from "element-plus";
import { storeToRefs } from "pinia";
import { useMainStore } from "../store/main";
import AddMonitoring from "../components/Add_Monitoring.vue";
import UserType from "../enums/UserType";
import { useSort } from "../composables/sort";
import { useI18n } from "vue-i18n";
import LoanAgreement from "../classes/DB_Entities/LoanAgreement";
import { useGenericMethodsVariables } from "../composables/genericMethodsVariables";
import monitoring from "../classes/DB_Entities/Monitoring";

let product_type = ref<any>();
const { showError } = useGenericMethodsVariables();
const { entityApprove } = useGenericMethodsVariables();
const { locale } = useI18n({ useScope: "global" });
const { t } = useI18n({ useScope: "global" });
const products = ref<any>([]);
const router = useRouter();
const pgrestapi = usePGRESTAPIStore();
const mainStore = useMainStore();
const { onSortChange, sortColumn, sortOrder } = useSort();
const { globalPortfolioID } = storeToRefs(mainStore);
const { globalDebtorID } = storeToRefs(mainStore);
const { globalLoanAgreementID } = storeToRefs(mainStore);
const statusOptions = [
  {
    value: "denounced",
    label: t("loan_agreement.denounced"),
  },
  {
    value: "non_performing",
    label: t("loan_agreement.non_performing"),
  },
  {
    value: "performing",
    label: t("loan_agreement.performing"),
  },
];
let filterMonitoringType = ref<string>("");
let dataList = ref([]);
let dataCount = ref(0);
let isLoading = ref(false);
let lastPage = ref(0);
let detailsVisible = ref(false);
let selectedRow = ref(0);
let SelectedGlobalLa = ref<string>("");
let activeLang = ref<string>("en");
const DeleteDialogVisible = ref(false);
let DeleteSelectedRow = ref(0);
let deleteVisible = ref(false);
let ΑddMonitoringVisible = ref(false);
let filterContractNumber = ref<string>("");
let filterFullName = ref<string>("");
let filterTaxRegistration = ref<string>("");
let filterProduct = ref<string>("");
let filterStatus = ref<string>("");
let timer = ref<any>(null);
let filterPendingNew = ref(false);
let filterHideRejected = ref(true);

watch(globalPortfolioID, async () => {
  if (mainStore.loggedUser.username !== '') // Do not load if user logged out (changes the value of globalLoanAgreementID to "")
    await loadPage(1);
});

watch(globalDebtorID, async () => {
  if (mainStore.loggedUser.username !== '') // Do not load if user logged out (changes the value of globalLoanAgreementID to "")
    await loadPage(1);
});

watch(globalLoanAgreementID, async () => {
  if (mainStore.loggedUser.username !== '') // Do not load if user logged out (changes the value of globalLoanAgreementID to "")
    await loadPage(1);
});

watch(locale, async () => {
  await loadPage(1);
});

const handleClickAdd = () => {
  ΑddMonitoringVisible.value = true;
};

const handleClick = (row_id: number) => {
  selectedRow.value = row_id;
  detailsVisible.value = true;
};
const get_monitoring_type = (row: any, column: any) => {
  return t(monitoring_types[parseInt(row[column.property])].label);
};
const deleteHandleClick = (row_id: number) => {
  DeleteSelectedRow.value = row_id;
  deleteVisible.value = true;
  DeleteMonitoring(row_id);
};

const onAdd = async () => {
  ElMessage({
    showClose: true,
    message: "Monitoring added Successfully",
    type: "success",
    duration: 1000,
  });

  ΑddMonitoringVisible.value = false;

  loadPage(lastPage.value);
};

const DeleteMonitoring = async (row_id: number) => {
  let result: PGRESTResult = new PGRESTResult();
  console.log(row_id);
  let id = JSON.stringify(row_id);
  result = await pgrestapi.delete_data("la_monitoring?id=eq." + id);

  if (result.error) {
    showError(result.error.message);

    DeleteDialogVisible.value = false;
    return;
  }

  onDelete();
};

onMounted(async () => {
  loadPage(1);
});

const loadPage = async (page: number) => {
  activeLang.value = locale.value as string;
  isLoading.value = true;

  lastPage.value = page;
  page = page - 1;
  
  let filterUrl = "";

  if (filterFullName.value !== "") {
    filterUrl += `&fullname=ilike.*${filterFullName.value}*`;
  }
  if (filterMonitoringType.value === "0"
    || filterMonitoringType.value === "1"
    || filterMonitoringType.value === "2"
    || filterMonitoringType.value === "3"

  ) {
    filterUrl += `&monitoring_type=eq.${filterMonitoringType.value}`;
  }

  let addedFilter = "";

  if (mainStore.globalPortfolioID !== "") {
    addedFilter += "&debtorportfolio=eq." + mainStore.globalPortfolioID;
  }

  if (mainStore.globalDebtorID !== "") {
    addedFilter += "&debtorid=eq." + mainStore.globalDebtorID;
  }

  if (mainStore.globalLoanAgreementID !== "") {
    SelectedGlobalLa.value = globalLoanAgreementID.value;
    addedFilter += "&loan_agreement_id=eq." + mainStore.globalLoanAgreementID;
  }
  if (mainStore.loggedUser.user_type == UserType.Agent) {
    addedFilter += `&allowed_users=cs.{${mainStore.loggedUser.id}}`;
  } else if (mainStore.loggedUser.user_type == UserType.Supervisor) {
    addedFilter += `&portfolio_allowed_users=cs.{${mainStore.loggedUser.id}}`;
  }
  if (sortOrder.value !== "") {
    filterUrl += `&order=${sortColumn.value}.${sortOrder.value}`;
  } else {
    filterUrl += `&order=portf_name.asc,fullname.asc,ar_sumbashs.asc`;
  }
  console.log('page', page)
  let result: PGRESTResult = await pgrestapi.getPaginated(
    "view_lamonitoring_view1?select=*" +
    addedFilter +
    filterUrl, +
  page
  );

  if (result.error) {
    showError(result.error.message);

    return;
  }

  if (result.headers)
    dataCount.value = parseInt(result.headers["content-range"].split("/")[1]);

  for (let item of result.data) {
    if (item.due_date) {
      item.due_date = DateTime.fromFormat((item.due_date) as string, "yyyy-MM-dd").setLocale('en-gb').toLocaleString();
    }
  }

  dataList.value = result.data;
  isLoading.value = false;
};

const onSave = async () => {
  selectedRow.value = -1;
  ElMessage({
    showClose: true,
    message: "Loan Agreement updated",
    type: "success",
    duration: 1000,
  });

  detailsVisible.value = false;
  loadPage(lastPage.value);
};

const onDelete = async () => {
  ElMessage({
    showClose: true,
    message: "Monitoring Deleted Successfully",
    type: "success",
    duration: 1000,
  });

  DeleteDialogVisible.value = false;
  loadPage(lastPage.value);
};
const monitoring_types = [
  {
    value: "0",
    label: "Monitoring.pending_issues",
  },
  {
    value: "1",
    label: "Monitoring.financials",
  },
  {
    value: "2",
    label: "Monitoring.asfalistiria",
  },
  {
    value: "3",
    label: "Monitoring.promitheies",
  },
];
const onFailSave = async () => {
  selectedRow.value = -1;
  ElMessage({
    showClose: true,
    message: "Monitoring failed to update",
    type: "error",
    duration: 2000,
  });

  detailsVisible.value = false;
};

const filterChanged = async (value: string) => {
  if (timer.value !== 0) {
    clearTimeout(timer.value);
  }

  timer.value = setTimeout(() => {
    loadPage(1);

    timer.value = 0;
  }, 500);
};

const localSortChange = async (sortObj: any) => {
  onSortChange(sortObj);
  await loadPage(lastPage.value);
};

const onClose = () => {
  detailsVisible.value = false;
  selectedRow.value = -1;
};

watch(globalLoanAgreementID, async () => {
  if (mainStore.loggedUser.username !== '') // Do not load if user logged out (changes the value of globalLoanAgreementID to "")
    SelectedGlobalLa.value = globalLoanAgreementID.value;
});

</script>

<template>
  <div class="content-wrapper" v-loading="isLoading">
    <el-row :gutter="10">
      <el-col :span="12">
        <h3 class="heading-page">
          Monitoring
        </h3>
      </el-col>
    </el-row>

    <div style="margin: 30px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-select clearable v-model="filterMonitoringType" class="m-2 client-input"
            :placeholder="$t('Monitoring.monitoring_type')" value-key="id" @change="filterChanged" style="width: 100%">
            <el-option v-for="item in monitoring_types" :key="item.value"
              :label="$t(monitoring_types[parseInt(item.value)].label)" :value="item.value" />
          </el-select>



          <!-- <el-input v-model="" class="client-input"
                :placeholder="$t('Monitoring.monitoring_type')" @input="filterChanged" />-->
        </el-col>
        <el-col :span="6">
          <el-input v-model="filterFullName" class="client-input" :placeholder="$t('DebtorDetailsView.company_fullname')"
            @input="filterChanged" />
        </el-col>
      </el-row>
    </div>

    <div>
      <el-row :gutter="10" style="margin: 10px; margin-top: 15px">
        <el-col :span="24" class="realestate-add-new-btn">
          <el-button link type="primary" size="small" class="btn-add" @click="loadPage(lastPage)"
            style="float: right; margin: 2.5px" :icon="RefreshLeft" />
          <el-button link type="primary" size="small" class="btn-add" style="float: right; margin: 2.5px"
            @click="handleClickAdd()" :icon="Plus" />
        </el-col>
      </el-row>
    </div>

    <el-table :data="dataList" stripe border table-layout="fixed" sortable="custom" @sort-change="localSortChange"
      size="small">
      <el-table-column sortable fixed prop="portf_name" :label="$t('SummaryChecks.portfolio')" />
      <el-table-column sortable fixed prop="fullname" label="Debtor" />
      <el-table-column sortable fixed prop="ar_sumbashs" :label="$t('LoanAgreementView.loan_agreement')" />
      <el-table-column fixed prop="monitoring_type" :formatter="get_monitoring_type"
        :label="$t('Monitoring.monitoring_type')" />
      <!-- <el-table-column sortable fixed prop="due_date" :label="$t('Monitoring.due_date')" /> -->
      <el-table-column fixed="right" :label="$t('global.operations')" width="280">
        <template #default="scope">
          <el-button type="primary" circle size="small" :icon="Edit" @click="handleClick(scope.row.id)" />
          <el-button v-if="mainStore.loggedUser.user_type === UserType.Administrator" type="danger" size="small"
            :icon="Delete" circle @click="DeleteDialogVisible = true; DeleteSelectedRow = scope.row.id;" />
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination size="small" layout="prev, pager, next" :page-size="10" :total="dataCount" @current-change="loadPage" />
    </div>

    <el-dialog v-if="detailsVisible" v-model="detailsVisible" @update:model-value="onClose" title="Monitoring Details" width="70%">
      <MonitoringDetails :rowid="selectedRow" @save="onSave" @close="onClose" @fail-save="onFailSave" />
    </el-dialog>

    <el-dialog v-if="ΑddMonitoringVisible" v-model="ΑddMonitoringVisible" title="Add Monitoring record">
      <AddMonitoring :globalla="SelectedGlobalLa" @close="ΑddMonitoringVisible = false" @save="onAdd" />
    </el-dialog>

    <el-dialog v-model="DeleteDialogVisible" title="Monitoring Delete" width="50%">
      <span>Are you sure you want to delete this row?</span>
      <template #footer #default="scope">
        <span class="dialog-footer">
          <el-button @click="DeleteDialogVisible = false">{{ $t('generic.cancel') }}</el-button>
          <el-button type="primary" @click="deleteHandleClick(DeleteSelectedRow)">{{ $t('generic.delete') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped></style>
